const ccProjectJson = {
    project_type: "javascript",
    debugMode: 1,
    showFPS: false,
    frameRate: 60,
    noCache: false,
    id: "gameCanvas",
    renderMode: 0,
    width: 768,
    height: 1024,
    engineDir: "frameworks/cocos2d-html5",
    modules: [
        "cocos2d",
        "extensions"
    ],
    jsList: []
};

export default function injectCCConfig(): void {
    window["CC_PROJECT_JSON"] = ccProjectJson;
}
